import type { AxiosResponse } from 'axios'

import type { CreateVoucherPayload } from '@/pages/VoucherManagement/queries/useVouchers'
import environment from '@/environments/environment.dev'

import HttpClient from '../apiHttpClient'

const VOUCHER_ENDPOINT = '/v1.0/voucher'

const adminFapiClient = new HttpClient(environment.adminFAPIUrl)

export interface Voucher {
  /** Unique identifier for the voucher */
  id: string
  /** Country identifier this voucher applies to */
  countryId: string
  /** Display name of the voucher */
  name: string
  /** Unique code used to redeem the voucher */
  voucherCode: string
  /** Discount amount */
  discount: number
  /** Discount type: 'Percentage' or 'Fixed' */
  discountType?: string
  /** ISO date string when the voucher becomes valid */
  startDate: string
  /** ISO date string when the voucher expires */
  endDate: string
}

export interface VoucherPayload {
  name: string
  /** Unique code used to redeem the voucher */
  voucherCode: string
  /** Discount amount */
  discount: number
  /** Discount type: 'Percentage' or 'Fixed' */
  discountType: string
  /** ISO date string when the voucher becomes valid */
  startDate: string
  /** ISO date string when the voucher expires */
  endDate: string
  /** Material numbers this voucher applies to */
  materialNumbers: string[]
  /** Category IDs this voucher applies to */
  categoryIds: number[]
}

export const adminVoucher = {
  getVouchersList: async (): Promise<AxiosResponse<Voucher[]>> => {
    return adminFapiClient.get(VOUCHER_ENDPOINT)
  },
  createVoucher: async (data: CreateVoucherPayload) => {
    return adminFapiClient.post(VOUCHER_ENDPOINT, {
      body: data,
    })
  },
  updateVoucher: async (voucherId: string, data: VoucherPayload) => {
    return adminFapiClient.put(`${VOUCHER_ENDPOINT}/${voucherId}/update`, {
      body: data,
    })
  },
  deleteVoucher: async (voucherId: string): Promise<AxiosResponse<unknown>> => {
    return adminFapiClient.delete(`${VOUCHER_ENDPOINT}/${voucherId}/delete`)
  },
}
